import { EntityItem } from '@epilot/customer-portal-client'

import { createGroupedMockData } from '../utils/mockGroupingUtils'

import {
  MOCK_CONTRACTS_FOR_SEARCH,
  MOCK_FILES_FOR_SEARCH,
  MOCK_METERS_FOR_SEARCH,
  MOCK_OPPORTUNITIES_FOR_SEARCH,
  MOCK_ORDERS_FOR_SEARCH
} from './search-entities'

export const MOCK_ENTITY_SEARCH_GROUPED_CONTRACTS = createGroupedMockData(
  MOCK_CONTRACTS_FOR_SEARCH as unknown as EntityItem[],
  'contract'
)

export const MOCK_ENTITY_SEARCH_GROUPED_DOCUMENTS = createGroupedMockData(
  MOCK_FILES_FOR_SEARCH as unknown as EntityItem[],
  'file'
)

export const MOCK_ENTITY_SEARCH_GROUPED_METERS = createGroupedMockData(
  MOCK_METERS_FOR_SEARCH as unknown as EntityItem[],
  'meter'
)

export const MOCK_ENTITY_SEARCH_GROUPED_OPPORTUNITIES = createGroupedMockData(
  MOCK_OPPORTUNITIES_FOR_SEARCH as unknown as EntityItem[],
  'opportunity'
)

export const MOCK_ENTITY_SEARCH_GROUPED_ORDERS = createGroupedMockData(
  MOCK_ORDERS_FOR_SEARCH as unknown as EntityItem[],
  'order'
)
